/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{destroyMaybe as t}from"../../../../../core/maybe.js";class e{constructor(t,e,s,i,o,r){this.transform=t,this.toMapSpace=e,this.obb=s,this.components=i,this.renderable=o,this.intersectionGeometry=r,this.visible=!1,this.offsetObb=null}destroy(){this.intersectionGeometry=t(this.intersectionGeometry),this.renderable=t(this.renderable),this.components=t(this.components)}}export{e as ComponentObject};
